<template>
  <div class="edit_main">
    <Form
      class="fx_1"
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="100"
      inline
    >
      <FormItem label="机构名称" prop="OrganName">
        <Input class="w-250" v-model="addModel.OrganName"></Input>
      </FormItem>
      <FormItem label="机构编号" prop="OrganCode">
        <Input class="w-250" v-model="addModel.OrganCode"></Input>
      </FormItem>

      <FormItem label="机构类型" prop="OrganType">
        <Select class="w-250" v-model="addModel.OrganType" clearable>
          <Option
            v-for="(item, index) in organTypeSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="机构英文名称" prop="OrganNameEN">
        <Input class="w-250" v-model="addModel.OrganNameEN"></Input>
      </FormItem>
      <FormItem label="机构电话" prop="OrganTell">
        <Input class="w-250" v-model="addModel.OrganTell"></Input>
      </FormItem>
      
      <FormItem label="经度" prop="organLongitude">
        <Input class="w-250" v-model="addModel.organLongitude"></Input>
      </FormItem>
      <FormItem label="纬度" prop="organLatitude">
        <Input class="w-250" v-model="addModel.organLatitude"></Input>
      </FormItem>
      <FormItem label="上级机构" prop="organParentName">
        <Button type="primary" @click="treeModel = true">选择上级机构</Button>
        <span class="ml-5">{{ organParentName }}</span>
      </FormItem>
      <FormItem label="选择行政区">
        <v-region :town="true" @values="regionChange" v-model="address"></v-region>
      </FormItem>
      <FormItem label="机构地址" prop="OrganAddress">
        <Input class="w-250" v-model="addModel.OrganAddress" disabled></Input>
      </FormItem>
      <FormItem label="备注" prop="Remark">
        <Input
          class="w-250"
          v-model="addModel.Remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <div class="edit_btn_group">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')"
        >确 定</Button
      >
    </div>

    <Modal v-model="treeModel" title="选择上级机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../organ/organTree.vue";

export default {
  components: { organTree },
  data: function () {
    return {
      organTypeSelect: [],
      treeModel: false,
      organParentName: "",
      address: {
        province: "",
        city: "",
        area: "",
        town: "",
      },
      addModel: {
        OrganName: "",
        OrganCode: "",
        OrganType: "",
        OrganTell: "",
        OrganAddress: "",
        Remark: "",
        OrganParentID: "",
        province: "",
        city: "",
        area: "",
        town: "",
        organLongitude: "",
        organLatitude: ""
      },
      ruleValidate: {
        OrganName: [
          {
            required: true,
            message: "机构名称不能为空",
          },
        ],
        OrganCode: [
          {
            required: true,
            message: "机构编号不能为空",
          },
        ],
        OrganType: [
          {
            required: true,
            message: "机构类型不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.$common.getDictionary("机构类型").then((data) => {
      this.organTypeSelect = data;
    });
  },

  methods: {
    returnBack: function () {
      this.$router.push("organ");
    },
    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("organ/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.organParentName=''
              this.address={
                province: "",
                city: "",
                area: "",
                town: "",
              }
              this.$refs["addModel"].resetFields();
              this.returnBack();
            }
          });
        }
      });
    },

    selectTreeData: function (data) {
      this.addModel.OrganParentID = data[0].organID;
      this.organParentName = data[0].title;
    },
    regionChange(data) {
      console.log(data,48);
      this.addModel.province = data.province ? data.province.key : "";
      this.addModel.city = data.city ? data.city.key : "";
      this.addModel.area = data.area ? data.area.key : "";
      this.addModel.town = data.town ? data.town.key : "";
      this.addModel.OrganAddress = data.province ? data.province.value : ''
    },
  },
};
</script>
<style scoped>
</style>